<template>
	<div class="leader-board-table">
		<div class="leader-board-table--wrapper">
			<div class="leader-board-table--wrapper-header row">
				<div class="col-1">Pos</div>
				<div class="col-4">Venue</div>
				<div class="col-1 text-center"></div>
				<div class="col text-center">Audits</div>
				<div class="col text-center">Latest Score</div>
				<div class="col text-center">Avg Score</div>
			</div>

			<div class="leader-board-table--wrapper-body">
				<div class="leader-board-table--row row" v-for="(row, index) in leader_board" v-on:click="selectVenue(row.venue)">
					<div class="col-1 py-0 px-2 text-center">
						<div class="leader-board-table--position">{{parseInt(index)+ 1}}</div>
					</div>
					<div class="col-4">
						<div class="w-100 leader-board-table--value">{{row.venue_name}}</div>
					</div>
					<div class="col-1 text-center">
						<i v-if="row.improved === true"><img src="@/images/up.svg" /></i>
						<i v-else-if="row.improved !== null"><img src="@/images/down.svg" /></i>
						<i v-else>-</i>
					</div>
					<div class="col text-center">
						{{row.num_audits}}
					</div>
					<div class="col text-center">
						<span class="text-pink">{{row.last_audit_score}}</span>
						<!-- <span v-if="row.last_audit_score < 70" class="text-pale-yellow">{{row.last_audit_score}}</span>
						<span v-else-if="row.last_audit_score < 80" class="text-yellow">{{row.last_audit_score}}</span>
						<span v-else>{{row.last_audit_score}}</span> -->
					</div>
					<div class="col text-center">
						<span class="text-pink">{{Math.round(row.avg_score_percentage) + "%"}}</span>
						<!-- <span v-if="row.avg_score_percentage < 70" class="text-pale-yellow">{{Math.round(row.avg_score_percentage) + "%"}}</span>
						<span v-else-if="row.avg_score_percentage < 80" class="text-yellow">{{Math.round(row.avg_score_percentage) + "%"}}</span>
						<span v-else>{{Math.round(row.avg_score_percentage) + "%"}}</span> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {venue_selection_bus} from '../../../vue_components';

	export default {
		props:[
			'leader_board'
		],

		methods:{
			selectVenue(venue){
				$(document.body).data('venue-selected', venue.value);
				venue_selection_bus.$emit('select', venue);
			}
		},
	}
</script>
